module.exports = __webpack_public_path__ + "static/media/clubs.560a3dfc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/school_money/guide/clubs.svg
// module id = 591
// module chunks = 0